/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddCategoryToPlanCommand } from '../../models/add-category-to-plan-command';
import { AddCategoryToPlanCommandResult } from '../../models/add-category-to-plan-command-result';

export interface ApiPlanAddCategoryToPlanPatch$Plain$Params {
  
    /**
     * Plan update command
     */
    body?: AddCategoryToPlanCommand
}

export function apiPlanAddCategoryToPlanPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanAddCategoryToPlanPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddCategoryToPlanCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanAddCategoryToPlanPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddCategoryToPlanCommandResult>;
    })
  );
}

apiPlanAddCategoryToPlanPatch$Plain.PATH = '/api/Plan/AddCategoryToPlan';
